module.exports = __webpack_public_path__ + "img/icon-basePar-2.962fce02.png";